import { initialize_push_notifications } from '@/services/push_notification_service';

export const navbar_notification_browser_methods = {
  should_request_notification_permission() {
    return process.env.VUE_APP_PUSH_LEGACY_NAV_PROMPT === 'true'
      && 'Notification' in window
      && Notification.permission === 'default';
  },

  async request_notification_permission() {
    initialize_push_notifications();

    if (!this.should_request_notification_permission()) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    this.fire_browser_notification(
      'Notifications enabled - AIC One',
      "You'll be notified of new messages and alerts even when this tab is in the background.",
      { tag: 'aic-welcome', icon: this.get_navbar_logo_src() }
    );
  },

  can_show_browser_notification() {
    return 'Notification' in window && Notification.permission === 'granted';
  },

  browser_notification_payload(body, options = {}) {
    const icon = options.icon ?? this.get_navbar_logo_src();
    return ({
      body,
      icon,
      badge: icon,
      tag: options.tag ?? 'aic-notification',
      requireInteraction: false,
      silent: false,
    });
  },

  run_notification_click(options = {}) {
    window.focus();
    options.on_click?.();
  },

  fire_browser_notification(title, body, options = {}) {
    if (!this.can_show_browser_notification()) return;

    const notif = new Notification(
      title,
      this.browser_notification_payload(body, options)
    );
    notif.onclick = () => this.handle_browser_notification_click(notif, options);
    setTimeout(() => notif.close(), 9000);
  },

  handle_browser_notification_click(notif, options) {
    this.run_notification_click(options);
    notif.close();
  },

  is_safe_notification_url(raw_url) {
    if (!raw_url.startsWith('http')) return true;

    const url_obj = new URL(raw_url);
    return url_obj.hostname === window.location.hostname;
  },

  resolve_notification_route(raw_url) {
    if (!raw_url.startsWith('http')) return raw_url;

    const url_obj = new URL(raw_url);
    return url_obj.pathname + url_obj.search + url_obj.hash;
  },

  push_notification_url(raw_url) {
    if (!raw_url) return;

    try {
      if (!this.is_safe_notification_url(raw_url)) return;

      this.$router.push(this.resolve_notification_route(raw_url));
    } catch {
      this.$router.push(raw_url);
    }
  },

  get_time_formatter(diff) {
    const formats = [
      [60, () => 'Just now'],
      [3600, () => `${Math.floor(diff / 60)}m ago`],
      [86400, () => `${Math.floor(diff / 3600)}h ago`],
      [604800, () => `${Math.floor(diff / 86400)}d ago`],
    ];
    return Reflect.get(
      formats.find(([limit]) => diff < limit) ?? [],
      1
    );
  },

  format_time_ago(timestamp) {
    if (!timestamp) return '';

    const time = new Date(timestamp);
    const diff = Math.floor((Date.now() - time.getTime()) / 1000);

    return this.get_time_formatter(diff)?.()
      ?? time.toLocaleDateString();
  },
};
